export const illustrationMappings = [
  "Left Far Lateral",
  "Left Foraminal",
  "Left Paracentral",
  "Central",
  "Right Far Lateral",
  "Right Foraminal",
  "Right Paracentral",
]

export const bulgesMappings = [
  "Anterior",
  "Posterior",
  "Circumferential",
  "Left Foraminal",
  "Right Foraminal",
]

export const mappingTypes = {
  pathology: {
    key: "pathology",
    label: "Herniation Mappings",
    singular: "Herniation Mapping",
    endpoint: "herniation-mappings",
    idKey: "HerniationMappingId",
    options: illustrationMappings,
  },
  bulges: {
    key: "bulges",
    label: "Bulges Mappings",
    singular: "Bulges Mapping",
    endpoint: "bulges-mappings",
    idKey: "BulgesMappingId",
    options: bulgesMappings,
  },
}
